import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const ArrowRight = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 25'
    >
      <path
        fill={primaryColorToUse}
        fillRule='evenodd'
        d='M11.356 4.665a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.415-1.414l5.293-5.293H5.063a1 1 0 1 1 0-2h11.585l-5.292-5.293a1 1 0 0 1 0-1.414'
        clipRule='evenodd'
      />
    </svg>
  );
};
